var Timeout = (function () {
    function Timeout(_delay) {
        var _this = this;
        this._delay = _delay;
        this._resolve = function () { };
        this._promise = new Promise(function (resolve) {
            _this._resolve = resolve;
        });
    }
    Timeout.prototype.onComplete = function (callback) {
        this._promise.then(callback);
    };
    Timeout.prototype.complete = function () {
        this._resolve();
        if (this._timeoutToken) {
            window.clearTimeout(this._timeoutToken);
        }
    };
    Timeout.prototype.start = function () {
        var _this = this;
        if (this._delay) {
            this._timeoutToken = window.setTimeout(function () { return _this.complete(); }, this._delay);
        }
    };
    return Timeout;
}());
export default Timeout;
